"use strict";
// Stremio Plus: profile avatars.
// New avatars come from DiceBear (https://www.dicebear.com) and are stored as
// "dicebear:<style>:<seed>". Seeds are random, never the profile name, so nothing
// personal is sent to DiceBear. Plain color keys are the older format.
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyAvatarColor = exports.avatarUrl = exports.parseAvatar = exports.makeAvatar = exports.randomSeed = exports.styleLabel = exports.AVATAR_STYLE_GROUPS = exports.DEFAULT_AVATAR_STYLE = exports.AVATAR_CHOICES = void 0;
var DICEBEAR_API = 'https://api.dicebear.com/9.x';
var DICEBEAR_PREFIX = 'dicebear:';
var BACKGROUND_COLORS = 'b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf,c1f4c5';
exports.AVATAR_CHOICES = 12;
exports.DEFAULT_AVATAR_STYLE = 'adventurer';
// Every DiceBear 9 style, grouped like a native <optgroup> select.
exports.AVATAR_STYLE_GROUPS = [
    {
        label: 'PLUS_AVATARS_GROUP_CHARACTERS',
        styles: [
            'adventurer', 'adventurer-neutral', 'avataaars', 'avataaars-neutral', 'big-ears', 'big-ears-neutral',
            'big-smile', 'dylan', 'lorelei', 'lorelei-neutral', 'micah', 'miniavs', 'notionists', 'notionists-neutral',
            'open-peeps', 'personas', 'toon-head',
        ],
    },
    {
        label: 'PLUS_AVATARS_GROUP_DRAWINGS',
        styles: ['croodles', 'croodles-neutral', 'fun-emoji', 'thumbs'],
    },
    {
        label: 'PLUS_AVATARS_GROUP_PIXEL',
        styles: ['bottts', 'bottts-neutral', 'pixel-art', 'pixel-art-neutral'],
    },
    {
        label: 'PLUS_AVATARS_GROUP_ABSTRACT',
        styles: ['glass', 'icons', 'identicon', 'initials', 'rings', 'shapes'],
    },
];
var LEGACY_COLORS = {
    default: '#7b5bf5',
    blue: '#3d8bfd',
    teal: '#20c5b5',
    green: '#3fb950',
    yellow: '#e3b341',
    orange: '#f0883e',
    red: '#f85149',
    pink: '#db61a2',
};
var styleLabel = function (style) { return style
    .split('-')
    .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
    .join(' '); };
exports.styleLabel = styleLabel;
var randomSeed = function () { return Math.random().toString(36).slice(2, 10); };
exports.randomSeed = randomSeed;
var makeAvatar = function (style, seed) { return "".concat(DICEBEAR_PREFIX).concat(style, ":").concat(seed); };
exports.makeAvatar = makeAvatar;
var parseAvatar = function (avatar) {
    if (!avatar.startsWith(DICEBEAR_PREFIX))
        return null;
    var _a = avatar.slice(DICEBEAR_PREFIX.length).split(':'), style = _a[0], seed = _a.slice(1);
    return style && seed.length > 0 ? { style: style, seed: seed.join(':') } : null;
};
exports.parseAvatar = parseAvatar;
var avatarUrl = function (style, seed) {
    var params = new URLSearchParams({ seed: seed, backgroundColor: BACKGROUND_COLORS, backgroundType: 'solid' });
    return "".concat(DICEBEAR_API, "/").concat(encodeURIComponent(style), "/svg?").concat(params);
};
exports.avatarUrl = avatarUrl;
var legacyAvatarColor = function (avatar) { var _a; return (_a = LEGACY_COLORS[avatar]) !== null && _a !== void 0 ? _a : LEGACY_COLORS.default; };
exports.legacyAvatarColor = legacyAvatarColor;
